import * as yup from "yup";
import { DocumentoRegex, TelefonoRegex } from "../utils/regex";

export const RepresentanteLegalSchema = yup.object().shape({
  nombre: yup
    .string()
    .max(100, "errors.representanteLegal.nombre.max")
    .required("errors.representanteLegal.nombre.required")
    .default(""),
  documento: yup
    .string()
    .matches(DocumentoRegex, "errors.representanteLegal.documento.regex")
    .min(7, "errors.representanteLegal.documento.min")
    .max(8, "errors.representanteLegal.documento.max")
    .required("errors.representanteLegal.documento.required")
    .default(""),
  cargo: yup
    .string()
    .max(100, "errors.representanteLegal.cargo.max")
    .required("errors.representanteLegal.cargo.required")
    .default(""),
  telefono: yup
    .string()
    .matches(TelefonoRegex, "errors.representanteLegal.telefono.regex")
    .required("errors.representanteLegal.telefono.required")
    .default(""),
  correoElectronico: yup
    .string()
    .email("errors.representanteLegal.correoElectronico.regex")
    .required("errors.representanteLegal.correoElectronico.required")
    .default(""),
});
